import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import CreditsApi from '../../services/api/CreditsApi';
import { CreditDetailsResponce } from '../../services/api/dto/Credits';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setCreditDetailsLoading = createAction<{
  value: boolean;
  name: 'details' | 'close' | 'getCredits';
}>('credit-details/setLoading');

const getCredits = createAsyncThunk(
  'credit-details/getCredits',
  async (
    payload: {
      count: number;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: true, name: 'getCredits' })
      );
      const store = thunkAPI.getState() as RootState;
      const { token, id } = store.auth.account;
      const response = await CreditsApi.getCredits(token, {
        ...payload,
        accountId: id,
      });
      if (response.status === 200) return response.data;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: false, name: 'getCredits' })
      );
    }

    return undefined;
  }
);

const getCreditDetails = createAsyncThunk(
  'credit-details/getDetails',
  async (
    payload: {
      id: number;
      accountId: number;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: true, name: 'details' })
      );
      const store = thunkAPI.getState() as RootState;
      const { token } = store.auth.account;
      const response = await CreditsApi.getDetailsCreditInfo(token, {
        ...payload,
      });
      if (response.status === 200) return response.data;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: false, name: 'details' })
      );
    }

    return undefined;
  }
);

const closeCredit = createAsyncThunk(
  'credit-details/closeCredit',
  async (
    payload: {
      id: number;
      accountId: number;
      creditInfo: CreditDetailsResponce;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: true, name: 'close' })
      );
      const store = thunkAPI.getState() as RootState;
      const { token } = store.auth.account;
      const response = await CreditsApi.closeCredit(token, { ...payload });
      if (response.status === 200) return response.data;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setCreditDetailsLoading({ value: false, name: 'close' })
      );
    }

    return undefined;
  }
);

export { setCreditDetailsLoading, getCreditDetails, closeCredit, getCredits };
